import Vue from "vue";
import Highcharts from 'highcharts';
import App from "./App.vue";

Vue.config.productionTip = false;

Vue.filter('formatNumber', function (value) {
  if (typeof value == 'undefined') return '';
  return value.toLocaleString('nl-NL');
});

Vue.filter('formatNumber1000', function (value) {
  if (typeof value == 'undefined') return '';
  return value.toLocaleString('nl-NL') + '.000'
});

Highcharts.setOptions({
  lang: {
    shortMonths: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
    months: [
      'januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'
    ]
  }
});

new Vue({
  render: h => h(App)
}).$mount("#app");
